var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 2.99805C7.02889 2.99805 2.99805 7.02889 2.99805 12.0011C2.99805 16.9732 7.02889 21.0021 11.9991 21.0021C16.9692 21.0021 21.0001 16.9712 21.0001 12.0011C21.0001 7.0309 16.9732 2.99805 12.0011 2.99805ZM12.0011 16.9109C9.44056 16.9109 7.33865 14.9518 7.11136 12.4516C7.08923 12.2103 7.2783 12.0011 7.52168 12.0011H16.4805C16.7218 12.0011 16.9129 12.2103 16.8908 12.4516C16.6635 14.9518 14.5596 16.9109 12.0011 16.9109Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.0b4a6d8a9b7845c1f119af5ae054c7f7.svg";
export { ForwardRef as ReactComponent };